import React, { Suspense, lazy } from "react";
import { Router, Switch, Route } from "react-router-dom";
import IdleTimer from "react-idle-timer";
import { history } from "./history";
import { connect } from "react-redux";
import Spinner from "./components/@vuexy/spinner/Loading-spinner";
import Utils from "utility/Utils";
import { ContextLayout } from "./utility/context/Layout";
import Auth, { AuthService } from "./auth/Auth";
import withReducer from "./redux/withReducer";
import reducer from "./views/pages/authentication/login/store/reducers";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-table/react-table.css";
import "assets/scss/plugins/extensions/react-tables.scss";
import "assets/scss/plugins/extensions/react-paginate.scss";
import "assets/scss/pages/data-list.scss";
import { PermissionContextProvider } from "./utility/context/Permission";

import { WorkflowConfig } from "./views/pages/workflowmanagement/WorkflowConfig";
import { CinemaConfig } from "./views/pages/cinemamanagement/CinemaConfig";

// Route-based code splitting
const routeConfigs = [WorkflowConfig, CinemaConfig];

const Home = lazy(() => import("./views/pages/dashboard/Home"));

const login = lazy(() => import("./views/pages/authentication/login/Login"));

const forgot_password = lazy(() =>
  import("./views/pages/authentication/login/ForgotPassword")
);

const lock_screen = lazy(() =>
  import("./views/pages/authentication/login/LockScreen")
);

const accountSettings = lazy(() =>
  import("./views/pages/accountsettings/AccountSettings")
);

const roleManagement = lazy(() =>
  import("./views/pages/rolemanagement/RoleManagement")
);

const customizationManagement = lazy(() =>
  import("./views/pages/customizationmanagement/CustomizationManagement")
);

const UserCreate = lazy(() =>
  import("./views/pages/usermanagement/UserCreateScreen")
);
const UserList = lazy(() =>
  import("./views/pages/usermanagement/UserListScreen")
);
const ProductList = lazy(() =>
  import("views/pages/productmanagement/ProductListScreen")
);
const SellerList = lazy(() =>
  import("views/pages/sellermanagement/SellerListScreen")
);
const MiddlemanList = lazy(() =>
  import("views/pages/middlemanmanagement/MiddlemanListScreen")
);
const PreSaleHome = lazy(() =>
  import("views/pages/presalemanagement/PresaleHome")
);
const PreSaleCreate = lazy(() =>
  import("views/pages/presalemanagement/PreSaleCreate")
);
const PreSalePrintPNR = lazy(() =>
  import("views/pages/presalemanagement/PreSalePrintPNR")
);
const TurnstileList = lazy(() =>
  import("views/pages/turnstilemanagement/TurnstileListScreen")
);
const CampaignList = lazy(() =>
  import("views/pages/campaignmanagement/CampaignListScreen")
);
const CategoriesManagement = lazy(() =>
  import("views/pages/categoriesmanagement/CategoriesList")
);
const TicketManagement = lazy(() =>
  import("views/pages/TicketManagement/TicketManagement/TicketManagement")
);
const bundleManagement = lazy(() =>
  import("./views/pages/bundlemanagement/BundleList")
);
const salesHomeScreen = lazy(() =>
  import("views/pages/saleshome/SalesHomeScreen")
);
const ticketSalesScreen = lazy(() =>
  import("views/pages/saleshome/TicketSales")
);
const cardSalesScreen = lazy(() => import("views/pages/saleshome/CardSales"));
const cardDetailScreen = lazy(() =>
  import("./views/pages/saleshome/CardDetails")
);
const ticketReturnScreen = lazy(() =>
  import("views/pages/saleshome/TicketReturn")
);
const cardReturnScreen = lazy(() => import("views/pages/saleshome/CardReturn"));
const reportManagement = lazy(() =>
  import("./views/pages/reportmanagement/reportList")
);
const reportAccounting = lazy(() =>
  import("./views/pages/reportmanagement/reportAccounting")
);
const depositMoney = lazy(() => import("./views/pages/saleshome/DepositMoney"));
const visitorSales = lazy(() => import("./views/pages/saleshome/VisitorSales"));
const userActivate = lazy(() =>
  import("./views/pages/authentication/login/UserActivate")
);
const BoothList = lazy(() =>
  import("./views/pages/boothmanagement/BoothListScreen")
);
const DiscountListScreen = lazy(() =>
  import("./views/pages/discountmanagement/DiscountListScreen")
);
const transferWristband = lazy(() =>
  import("./views/pages/saleshome/TransferWristband")
);
const VisitorManagement = lazy(() =>
  import("./views/pages/visitorManagement/VisitorListScreen")
);
const VisitorCreate = lazy(() =>
  import("./views/pages/visitorManagement/VisitorCreateScreen")
);
const VisitorShow = lazy(() =>
  import("./views/pages/visitorManagement/VisitorShowScreen")
);
const TicketList = lazy(() => import("./views/pages/saleshome/TicketList"));
const PresaleList = lazy(() =>
  import("./views/pages/saleshome/PresaleTickets")
);

// Set Layout and Component Using App Route
const RouteConfig = ({
  component: Component,
  fullLayout,
  permission,
  centeredLayout,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      return (
        <ContextLayout.Consumer>
          {(context) => {
            let LayoutTag =
              fullLayout === true
                ? context.fullLayout
                : context.state.activeLayout === "horizontal"
                ? context.horizontalLayout
                : context.VerticalLayout;
            return (
              <LayoutTag
                {...props}
                centeredLayout={centeredLayout}
                permission={props.user}
              >
                <Suspense fallback={<Spinner />}>
                  <Component {...props} routeprops={rest} />
                </Suspense>
              </LayoutTag>
            );
          }}
        </ContextLayout.Consumer>
      );
    }}
  />
);

const mapStateToProps = (state) => {
  return {
    user: state.auth.login.userRole,
  };
};

const AppRoute = withReducer(
  "routerReducer",
  reducer
)(connect(mapStateToProps)(RouteConfig));

export default class AppRouter extends React.Component {
  constructor(props) {
    super(props);
    this.idleTimer = null;
  }

  render() {
    return (
      // Set the directory path if you are deploying in sub-folder
      <Router history={history}>
        <Auth>
          <IdleTimer
            ref={(ref) => {
              this.idleTimer = ref;
            }}
            timeout={1000 * 60 * 10}
            onActive={(...args) => {
              AuthService.emit("onIdleActive", ...args);
            }}
            onIdle={(...args) => {
              AuthService.emit("onIdleTimeout", ...args);
            }}
            onAction={(...args) => {
              AuthService.emit("onIdleAction", ...args);
            }}
            debounce={250}
          />
          <PermissionContextProvider>
            <Switch>
              <AppRoute exact path="/" component={Home} />
              <AppRoute
                path="/activate/:token"
                component={userActivate}
                fullLayout
              />
              <AppRoute path="/login" component={login} fullLayout />
              <AppRoute
                path="/forgotPassword"
                component={forgot_password}
                fullLayout
              />
              <AppRoute path="/lockscreen" component={lock_screen} fullLayout />
              <AppRoute path="/accountsettings" component={accountSettings} />
              <AppRoute path="/roleManagement" component={roleManagement} />
              <AppRoute path="/product/list" component={ProductList} />
              <AppRoute path="/seller/list" component={SellerList} />
              <AppRoute path="/middleman/list" component={MiddlemanList} />
              <AppRoute path="/booth/list" component={BoothList} />
              <AppRoute path="/visitor/create" component={VisitorCreate} />
              <AppRoute
                path="/visitor/show/:visitorId"
                component={VisitorShow}
              />
              <AppRoute path="/visitor/list" component={VisitorManagement} />
              <AppRoute
                path="/discountmanagement"
                component={DiscountListScreen}
              />
              <AppRoute path="/presale/home" component={PreSaleHome} />
              <AppRoute
                path="/onlinesale/home"
                component={PreSaleHome}
                isOnline={true}
              />
              <AppRoute path="/presale/create" component={PreSaleCreate} />
              <AppRoute
                path="/presale/detail/:presaleId"
                component={PreSalePrintPNR}
              />
              <AppRoute path="/user/create" component={UserCreate} />
              <AppRoute path="/user/edit/:userId" component={UserCreate} />
              <AppRoute path="/user/list" component={UserList} />
              <AppRoute path="/turnstile/list" component={TurnstileList} />
              <AppRoute
                path="/categoriesManagement"
                component={CategoriesManagement}
              />
              <AppRoute
                path="/customizationManagement"
                component={customizationManagement}
              />
              <AppRoute path="/campaignmanagement" component={CampaignList} />
              <AppRoute path="/ticket/list" component={TicketManagement} />
              <AppRoute path="/bundleManagement" component={bundleManagement} />
              <AppRoute
                path="/sales/home"
                component={salesHomeScreen}
                fullLayout
              />
              <AppRoute
                path="/sales/ticketsales"
                component={ticketSalesScreen}
                fullLayout
                centeredLayout={false}
              />
              <AppRoute
                path="/sales/carddetail"
                component={cardDetailScreen}
                fullLayout
                centeredLayout={false}
              />
              <AppRoute
                path="/sales/cardsales"
                component={cardSalesScreen}
                fullLayout
                centeredLayout={false}
              />
              <AppRoute
                path="/sales/ticketreturn"
                component={ticketReturnScreen}
                fullLayout
                centeredLayout={false}
              />
              <AppRoute
                path="/sales/cardreturn"
                component={cardReturnScreen}
                fullLayout
                centeredLayout={false}
              />
              <AppRoute
                path="/sales/depositmoney"
                component={depositMoney}
                fullLayout
                centeredLayout={false}
              />
              <AppRoute
                path="/sales/visitorSales"
                component={visitorSales}
                fullLayout
                centeredLayout={false}
              />
              <AppRoute
                path="/sales/ticketsearch"
                component={TicketList}
                fullLayout
                centeredLayout={false}
              />
              <AppRoute
                path="/sales/presale"
                component={PresaleList}
                fullLayout
                centeredLayout={false}
              />
              <AppRoute
                path="/sales/transferwristband"
                component={transferWristband}
                fullLayout
                centeredLayout={false}
              />
              <AppRoute path="/reportManagement" component={reportManagement} />
              <AppRoute path="/reportAccounting" component={reportAccounting} />
              {Utils.generateRoutesFromConfigs(routeConfigs).map((item) => {
                return <AppRoute {...item} key={item.path} />;
              })}
            </Switch>
            <ToastContainer position="bottom-left" />
          </PermissionContextProvider>
        </Auth>
      </Router>
    );
  }
}
